import React from 'react';
import { AboutMe } from './components/about/aboutMe';
import Main from './components/main/main';
import './App.scss';
import { Experience } from './components/experience/experience';
import { NavBar } from './components/navbar'
import { Skills } from './components/skills';
import { SpeedDialComp } from './components/speedDial';
import { Contact } from './components/contact';
import { Projects } from './components/projects';


const App = () => {
 
  return (
    <div className="main">
      <NavBar />
      <div id="main-content">
        <Main />
        <AboutMe />
        <Skills />
        <Experience />
        <Projects />
        <Contact />
      </div>
      <SpeedDialComp />
    </div>
  );
}

export default App;
